import { Box, Button, Card, CardContent, CardHeader, IconButton, Menu, MenuItem, Pagination, Paper, Select, SelectChangeEvent, Stack, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useCallback, useEffect, useState,KeyboardEvent } from "react";
import { useNavigate } from "react-router-dom";
import { T_Inquery } from "../../common/model/InqueryModel";
import { useProgress } from "../../contexts/ProgressContextProvider";
import { T_Page } from "../../common/model/apiModel";
import apis from "../../common/apis";
import { T_Param } from "../../common/model/paramModle";
import { T_Error } from "../../common/model/errorModel";
import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { T_user } from "../../common/model/user";
import { Search, SearchIconWrapper, StyledInputBase, StyledTableCell } from '../../common/style/styles';
import SearchIcon from '@mui/icons-material/Search';


const userRoleMap: Record<string, string> = {
  'ADMIN': '관리자',
  'MANAGER': '담당자',
  'USER': '사용자',
  'GUEST': '미인증',
};

export default function UserList(){
    const navigator = useNavigate();

    const pagesize = 10;
    const [page,setPage] = useState(1);
    const [list,setList] =  useState<T_user[] | null>(null);
    const {showProgress,setShowProgress} = useProgress();
    const [pageInfo,setPageInfo] = useState<T_Page>()
    const [role,setRole] = useState("all");
 const [skeyword,setSkeyword]=useState("");
        
    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
      };

    const getList = useCallback(async () => {
        try {
          setShowProgress(true);
          const result = await apis.user.userList(
            {
              page:Number(page),
              pagesize:pagesize,
              role:role
            }
          );
          console.log("resut:",result)
            if(result.code=="1"){
            
                setList(result.data.list);
                setPageInfo(result.data);
                setShowProgress(false);
    
            }else{
                 
              setShowProgress(false);
            }
    
       
    
        } catch (err: any) {
          setShowProgress(false);
        }
      }, [page,role,skeyword]);

      useEffect(() => {
          getList();
      }, [page,role]);
    
      function onKeyDown(e: KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
         if (e.key === 'Enter') {
           e.preventDefault(); // form 리프레시 방지
             getList()
         }
       }   

      
     const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
      const [menuRow, setMenuRow] = useState<number | null>(null)
      const open = Boolean(anchorEl);
      const handleClick = (e: React.MouseEvent<HTMLElement>, idx: number) => {
        setAnchorEl(e.currentTarget)
        setMenuRow(idx)
      }   
      const handleClose = () => {
          setAnchorEl(null);
          setMenuRow(null);
        }; 
   

    return(
        <Box sx={{ width: '100%' }}>
      <Card sx={{width:'100%'}} >
        <CardHeader sx={{pr:5,pb:0,mb:0}} title="회원 관리"  action={
   <Stack   direction="row"
                justifyContent="space-between"  // ← 여기만 바꿔주세요
                spacing={2}                     // 아이템 사이 약간의 간격
                sx={{ pt: 5, width: '100%' }}   // 전체 너비 확보
                >
          <Select
            value={role}
            size="small"
            onChange={(event:SelectChangeEvent)=>{
              setRole(event.target.value)
            }}
          >
            <MenuItem value="all">전체</MenuItem>
            <MenuItem value="ADMIN">관리자</MenuItem>
            <MenuItem value="MANAGER">담당자</MenuItem>
            <MenuItem value="USER">사용자</MenuItem>
            <MenuItem value="GUEST">미승인</MenuItem>
          </Select>
                  <Button variant="outlined" onClick={()=>{
                    navigator("/user/insert")
                  }}>
                   관리자등록
                  </Button></Stack>
                } />
        <CardContent>
        <TableContainer component={Paper}>
      <Table  aria-label="simple table" sx={{width:'100%'}}>
        <TableHead>
          <TableRow>
            <StyledTableCell  sx={{width:100,textAlign:'center'}}>아이디</StyledTableCell>
            <StyledTableCell align="right" sx={{width:'15%',textAlign:'center'}} >이름</StyledTableCell>
            <StyledTableCell align="right"  sx={{width:'30%',textAlign:'center'}}>회사명</StyledTableCell>
            <StyledTableCell align="right"  sx={{width:'30%',textAlign:'center'}}>사업자번호</StyledTableCell>
            <StyledTableCell align="right"  sx={{width:'15%',textAlign:'center'}}>권한</StyledTableCell>
            <StyledTableCell align="right"  sx={{textAlign:'center'}}>비고</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {list && list.map((item,index) => (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {item.userId}
              </TableCell>
              <TableCell align="center">{item.userNm}</TableCell>
              <TableCell align="left">{item.bizName}</TableCell>
              <TableCell align="left">{item.bizRegNo}</TableCell>
              <TableCell align="center">
                   {userRoleMap[String(item.role)] ?? '미지정'}
                </TableCell>
              <TableCell align="center">{ <>
                    <IconButton
                      aria-label="menu"
                      onClick={(e) => handleClick(e, index)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={menuRow === index}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleClose()
                          navigator("/user/edit",{state:{item:item}})  
                        }}
                      >
                        수정
                      </MenuItem>
                      <MenuItem
                        onClick={async() => {
                          handleClose()
                       //   handleDataDel(item)
                        }}
                      >
                        삭제
                      </MenuItem>
                    </Menu>
                  </>}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
        <Stack   direction="row"
  justifyContent="flex-end"
  alignItems="center" sx={{pt:5,justifyContent:'center',alignContent:'center',justifyItems:'center',alignItems:'ceter'}}>
        <Pagination count={pageInfo?.pages} showFirstButton showLastButton  onChange={handleChange}/>
        </Stack>
        </CardContent>
      </Card>
      </Box>
    )
}